import {
    type ICalendarDate,
    type I18nTextType,
    type YearType,
    type MonthType,
    type DayType,
    type JulianDateType,
    type WeekIndexType,
    type TimeStepType,
    type DateTime,
} from './types';
import {weeksNames} from './text.i18n';

function ZellerISOWeekday(year: YearType, base0month: number, day: DayType): WeekIndexType {
    let shift = base0month + 2;
    if (shift <= 3) {
        shift += 12;
        year -= 1;
    }

    return ((day +
        Math.floor(shift * 2.6) +
        year +
        Math.floor(year / 4) +
        6 * Math.floor(year / 100) +
        Math.floor(year / 400) -
        2) %
        7) as WeekIndexType;
}

export function jd2Date(JDN: JulianDateType): [YearType, MonthType, DayType] {
    const [year, month, day] = j2da(JDN);
    return [year, (month + 1) as MonthType, day];
}

function j2da(JDN: JulianDateType): [YearType, number, DayType] {
    const y = 4716;
    const v = 3;
    const j = 1401;
    const u = 5;
    const m = 2;
    const s = 153;
    const n = 12;
    const w = 2;
    const r = 4;
    const B = 274277;
    const p = 1461;
    const C = -38;
    const f = JDN + j + Math.floor((Math.floor((4 * JDN + B) / 146097) * 3) / 4) + C;
    const e = r * f + v;
    const g = Math.floor((e % p) / r);
    const h = u * g + w;
    const D = Math.floor((h % s) / u) + 1;
    const M = ((Math.floor(h / s) + m) % n) + 1;
    const Y = Math.floor(e / p) - y + Math.floor((n + m - M) / n);
    return [Y, M - 1, D as DayType];
}

export function JulianDateToCalendarDate(JDN: JulianDateType): ICalendarDate {
    const [year, month, day] = jd2Date(JDN);
    return {year, month, day};
}

export function julianDate(year: YearType, month: MonthType, day: DayType): JulianDateType {
    return JDN(year, month - 1, day);
}

function JDN(year: YearType, month: number, day: DayType): JulianDateType {
    const a = Math.floor((13 - month) / 12);
    const y = year + 4800 - a;
    const m = month + 12 * a - 2;

    return (
        day +
        Math.floor((153 * m + 2) / 5) +
        365 * y +
        Math.floor(y / 4) -
        Math.floor(y / 100) +
        Math.floor(y / 400) -
        32045
    );
}

export function NormalizedZeller(year: YearType, month: MonthType, day: DayType): WeekIndexType {
    return ZellerISOWeekday(year, month - 1, day) as WeekIndexType;
}

export function getWeekDay({year, month, day}: ICalendarDate): I18nTextType {
    return weeksNames[NormalizedZeller(year, month, day)];
}

export function getMonthDaysList(year: YearType, month: MonthType): DayType[] {
    const firstJDN = julianDate(year, month, 1);
    const lastJDN = getNextMonth(year, month);
    const countDays = lastJDN - firstJDN;

    return Array.from(Array(countDays).keys()).map((item) => item + 1) as DayType[];
}

export function getNextMonth(year: YearType, month: MonthType): JulianDateType {
    if (month === 12) {
        return julianDate(year + 1, 1, 1);
    }
    return julianDate(year, (month + 1) as MonthType, 1);
}

export function getPrevMonth(year: YearType, month: MonthType): JulianDateType {
    if (month === 1) {
        return julianDate(year - 1, 12, 1);
    }
    return julianDate(year, (month - 1) as MonthType, 1);
}

export function monthFirstDayShiftList(year: YearType, month: MonthType): number[] {
    const weekIndex = NormalizedZeller(year, month, 1);
    return Array.from(Array(weekIndex).keys());
}

export function getMoment(): DateTime {
    const today = new Date();

    return {
        date: julianDate(today.getFullYear(), (today.getMonth() + 1) as MonthType, today.getDate() as DayType),
        time: {
            hours: today.getHours(),
            minutes: today.getMinutes() as TimeStepType,
            seconds: today.getSeconds() as TimeStepType,
        },
    };
}